import { themeUi } from '../../themeUi/themeUi';

const radiusAndShadow = {
  boxShadow: themeUi.core.shadow.shadow200,
  backgroundColor: themeUi.semantic.color.background.neutral100
};

export default radiusAndShadow;
